var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViolationsActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.2225 10.3823L9.73252 1.89227C9.35002 1.29977 8.70502 0.947266 8.00002 0.947266C7.29502 0.947266 6.65002 1.29977 6.26752 1.89227L0.777522 10.3823C0.357522 11.0273 0.327522 11.8148 0.695022 12.4898C1.06252 13.1648 1.73752 13.5698 2.51002 13.5698H13.4975C14.2625 13.5698 14.945 13.1648 15.3125 12.4898C15.68 11.8148 15.65 11.0273 15.23 10.3823H15.2225ZM14.315 11.9498C14.15 12.2573 13.8425 12.4373 13.49 12.4373H2.51002C2.15752 12.4373 1.85002 12.2573 1.68502 11.9498C1.52002 11.6423 1.53502 11.2823 1.72252 10.9898L7.21252 2.49977C7.38502 2.22977 7.67752 2.07227 8.00002 2.07227C8.32252 2.07227 8.60752 2.22977 8.78752 2.49977L14.2775 10.9898C14.465 11.2823 14.48 11.6423 14.315 11.9498Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8 9.0625C8.3075 9.0625 8.5625 8.8075 8.5625 8.5V4.75C8.5625 4.4425 8.3075 4.1875 8 4.1875C7.6925 4.1875 7.4375 4.4425 7.4375 4.75V8.5C7.4375 8.8075 7.6925 9.0625 8 9.0625Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.01514 10.1875C7.70764 10.1875 7.45264 10.4425 7.45264 10.75C7.45264 11.0575 7.70764 11.3125 8.01514 11.3125C8.32264 11.3125 8.57764 11.0575 8.57764 10.75C8.57764 10.4425 8.33014 10.1875 8.01514 10.1875Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViolationsActivity);
export default __webpack_public_path__ + "static/media/violations-activity.fa37a72abdd728b156b60704b1a3e84f.svg";
export { ForwardRef as ReactComponent };